export default () => jQuery(($) => {
    // todo: handle fragments
    // todo: a11y touch-up

    const mbsAccordion = $('.mbs-class-list').length > 0;

    $('.accordion__item').removeClass('accordion__item--initial');

    const setAriaAttrs = function (item, button) {
        if (item.hasClass('accordion__item--open')) {
            button.attr('aria-label', 'Currently open. Click to close.').attr('aria-expanded', 'true');
        } else {
            button.attr('aria-label', 'Currently closed. Click to open.').attr('aria-expanded', 'false');
        }
    };
    let hashes = [];
    if (window.location.hash && mbsAccordion === false) {
        hashes = window.location.hash.substr(1).split(',');
    }
    $('.accordion__title').each(function () {
        const button = $('<button class="accordion__toggler">');
        const content = $(this).siblings('.accordion__content').first();
        const item = $(this).parents('.accordion__item').first();
        const accordion = $(this).parents('.accordion').first();
        content.attr('role', 'region');
        if ($(this).attr('id')) {
            button.attr('id', `${$(this).attr('id')}__toggler`);
        }
        if (content.attr('id')) {
            button.attr('aria-controls', content.attr('id'));
        }
        if (button.attr('id')) {
            content.attr('aria-labelledby', button.attr('id'));
        }
        if (accordion.hasClass('accordion--default-open') || (item.attr('id') && hashes.indexOf(item.attr('id')) > -1) && mbsAccordion === false) {
            item.addClass('accordion__item--open');
        } else {
            item.addClass('accordion__item--closed');
        }
        setAriaAttrs(item, button);
        button.click(function (e) {
            e.preventDefault();
            item.toggleClass('accordion__item--open').toggleClass('accordion__item--closed').addClass('accordion__item--transition').addClass('accordion__item--transition-start');
            setTimeout(() => {
                item.removeClass('accordion__item--transition-start');
            }, 10);
            setTimeout(() => {
                item.removeClass('accordion__item--transition');
            }, 500);
            setAriaAttrs(item, $(this));
            if (item.attr('id') && mbsAccordion === false) {
                const openIds = [];
                $.each($('.accordion__item--open'), (index, value) => {
                    openIds.push($(value).attr('id'));
                });
                var url;
                if (openIds.length) {
                    url = `#${openIds.join(',')}`;
                } else if (window.location.hash.includes('tabPanel')) {
                    var url = window.location.hash;
                } else {
                    url = window.location.pathname + window.location.search;
                }
                window.history.replaceState('', document.title, url);
            }
        });
        $(this).wrapInner(button);
    });
});
